export default {
  'component.portalVersion.guide.title': '新版使用指引',
  'component.portalVersion.guide.start': '开始使用新版',
  'component.portalVersion.guide.classic': '切回经典版',
  'component.portalVersion.guide.intro': '新版调整了菜单分组和发布页面，常用功能可从以下入口找到：',
  'component.portalVersion.guide.release':
    '发布页面已调整为发布工作台，可切换环境、筛选发布单，并集中查看发布范围、审批和执行状态。',
  'component.portalVersion.guide.transition':
    '当前保留新版和经典版是为了过渡，方便大家逐步熟悉新版。',
  'component.portalVersion.guide.workbench': '工作台：我的工作台、审批中心、周报等日常工作。',
  'component.portalVersion.guide.collaboration': '研发协同：需求、迭代、任务和测试等协作事项。',
  'component.portalVersion.guide.delivery': '交付中心：发布工作台、发布日历、服务视图和发布记录。',
  'component.portalVersion.guide.operations': '生产保障：K8s、技术管理、值班表等运维功能。',
  'component.portalVersion.guide.switch':
    '暂时不习惯新版？可随时通过页面顶部的“经典版 / 新版”切换入口返回经典版。',
  'component.portalVersion.tip': '切换后会保留当前页面并刷新菜单',
  'component.portalVersion.classic': '经典版',
  'component.portalVersion.v2': '新版',
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
};
